// Thin fetch wrapper around the Vīnoga API. Expanded as endpoints land.

const API_BASE = import.meta.env.VITE_API_URL ?? "http://localhost:3004";
export const ADMIN_TOKEN_KEY = "vinoga_admin_token";

export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly code: string,
    message: string
  ) {
    super(message);
    this.name = "ApiError";
  }
}

export async function api<T = unknown>(
  path: string,
  init: RequestInit = {}
): Promise<T> {
  const token = localStorage.getItem(ADMIN_TOKEN_KEY);
  const res = await fetch(`${API_BASE}${path}`, {
    ...init,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(init.headers ?? {}),
    },
  });

  if (!res.ok) {
    let code = "unknown_error";
    let message = `${res.status} ${res.statusText}`;
    try {
      const body = await res.json();
      if (body && typeof body.error === "string") {
        code = body.error;
        message = body.error;
      }
    } catch {
      // body wasn't JSON
    }
    throw new ApiError(res.status, code, message);
  }

  return (await res.json()) as T;
}
